import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
@Component({
  selector: 'app-archive-industry',
  templateUrl: './archive-industry.component.html',
  styleUrls: ['./archive-industry.component.css']
})
export class ArchiveIndustryComponent implements OnInit {

  public apiBaseUrl: string = environment.apiBaseUrl;
  public state: string = environment.state;
  production = environment.production;
  route:string;
  allIndustriesDetails = [];
  allCityList = [];
  searchField = {
    'status':'',
    'indCategory':'',
    'district':'',
    'address':'',
    'vendorName':'',
    'industryId':'',
    'industryName':'',
    'emmisionType':'',
    'region':'',
    'categoryType':''

  };
  regionList = [];
  userData:any = [];
  vendorList:any = [];
  userLevel = null;
  userName = null;
  industryListLoader = false;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }

    this.getVendorList();
    this.getRegionList();
    this.getCityList();
    this.getAllIndustryDetails();
  }

  getVendorList(){

    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.vendorList = response.data;
      }
    });

  }

  deleteIndustry(industryId){

    swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this industry and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.route  = 'delete-industry';
        const token = localStorage.getItem('userToken');
        let data = {'industry_id':industryId};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            swal("Successfully deleted industry details");
            this.getAllIndustryDetails();
          }
          if(response.status == 409){
            swal("Deletion not possible: "+response.message);
            this.getAllIndustryDetails();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  getRegionList(){
    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
      }
    });
  }

  getCityList(){

    this.route  = 'get-all-city-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.allCityList = response.data;
      }
    });

  }

  getAllIndustryDetails(){

    this.industryListLoader = true;
    this.route  = 'get-archive-industry-list';
    const token = localStorage.getItem('userToken');
    this.allIndustriesDetails = [];

    let data = {'search_fields':this.searchField};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.allIndustriesDetails = response.data;
        console.log(this.allIndustriesDetails);
      }
      this.industryListLoader = false;
    });
  }

  exportReport(fileType) {

    var a;
    this.route  = 'get-all-industry-details';
    let data = {'search_fields':this.searchField};
    const token = localStorage.getItem('userToken');

    a = document.getElementById('export'+fileType+'href');
    a.href = this.apiBaseUrl +"/archive-industry-list-export/"+fileType
      +"/"+(data['search_fields']['address'] ? btoa(data['search_fields']['address']) : btoa(null))
      +"/"+(data['search_fields']['categoryType'] ? btoa(data['search_fields']['categoryType']) : btoa(null))
      +"/"+(data['search_fields']['district'] ? btoa(data['search_fields']['district']) : btoa(null))
      +"/"+(data['search_fields']['emmisionType'] ? btoa(data['search_fields']['emmisionType']) : btoa(null))
      +"/"+(data['search_fields']['indCategory'] ? btoa(data['search_fields']['indCategory']) : btoa(null))
      +"/"+(data['search_fields']['industryId'] ? btoa(data['search_fields']['industryId']) : btoa(null))
      +"/"+(data['search_fields']['industryName'] ? btoa(data['search_fields']['industryName']) : btoa(null))
      +"/"+(data['search_fields']['region'] ? btoa(data['search_fields']['region']) : btoa(null))
      +"/"+(data['search_fields']['status'] ? btoa(data['search_fields']['status']) : btoa(null))
      +"/"+(data['search_fields']['vendorName'] ? btoa(data['search_fields']['vendorName']) : btoa(null))
      +"/"+token;

    document.getElementById('export'+fileType+'href').click();

  }

}
